module.exports = __webpack_public_path__ + "media/images/unite2-c53cd6555eeaa7d40533b927d6532454.png";